import { useQuery } from "@tanstack/react-query";
import { HttpProject } from "tekkr-common/dist/model/project/project";
import { apiClient } from "../service/tekkr-service";

export function useGetProjectQuery(projectId: string) {
    return useQuery({
        queryKey: ["project", projectId],
        queryFn: async (): Promise<HttpProject> => {
            const res = await apiClient.getProject({
                params: {
                    id: projectId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to fetch project");
            }
            return res.body.data as HttpProject;
        },
    });
}
